import { Injectable } from '@angular/core';
import { Route, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';

@Injectable({
  providedIn: 'root',
})
export class MsalAccountService {
  constructor(private msalService: MsalService, private router: Router) {}

  allowedUrlsByRoles(accountRoles: string[]): Route[] {
    // Obtenemos root Children
    const routes = this.router.config[0].children;
    return (
      routes
        // filtramos primero para que sólo nos vengan aquellos que tienen data
        .filter((route) => !!route.data)
        // filtramos por aquellos cuyo valor "roles" en data, contenga al menos uno de los roles de la cuenta
        .filter((route) => {
          const routeRoles = route.data.roles as string[];
          return accountRoles.some((accountRole) =>
            routeRoles.some((routeRol) => routeRol === accountRole)
          );
        })
    );
  }

  getAccountInfo(): AccountInfo {
    return (
      this.msalService.instance.getAllAccounts()[0] ||
      this.msalService.instance.getActiveAccount()
    );
  }
}
